import { render } from "./CookieMessage.vue?vue&type=template&id=133cef94&scoped=true"
import script from "./CookieMessage.vue?vue&type=script&lang=js"
export * from "./CookieMessage.vue?vue&type=script&lang=js"

import "./CookieMessage.vue?vue&type=style&index=0&id=133cef94&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133cef94"]])

export default __exports__